import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface StatCardData {
  label: string;
  value: number | string | null;
  supportingText?: string;
  icon: string;
  iconColor: string;
}

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'lib-stats-card',
  template: `
    <div class="overflow-hidden border border-gray-200 rounded-lg bg-white">
      <div class="p-5">
        <div class="flex items-center">
          @if (loading()) {
          <div class="flex items-center w-full animate-pulse">
            <div class="flex-shrink-0 h-6 w-6 rounded bg-gray-200"></div>
            <div class="ml-5 w-0 flex-1">
              <div class="h-3 w-24 rounded bg-gray-200 mb-2"></div>
              <div class="h-5 w-16 rounded bg-gray-200"></div>
            </div>
          </div>
          } @else {
          <div class="flex-shrink-0">
            <svg
              [class]="'h-6 w-6 ' + data().iconColor"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                [attr.d]="data().icon"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              ></path>
            </svg>
          </div>
          <div class="ml-5 w-0 flex-1">
            <dl>
              <dt class="text-sm font-medium text-gray-600 truncate">
                {{ data().label }}
              </dt>
              <dd class="text-lg font-medium text-gray-900">
                @if (numericValue() !== null) {
                {{ numericValue() | number }}
                } @else {
                {{ textValue() }}
                }
              </dd>
              @if (data().supportingText) {
              <dd class="mt-0.5 text-xs text-gray-500 truncate">
                {{ data().supportingText }}
              </dd>
              }
            </dl>
          </div>
          }
        </div>
      </div>
    </div>
  `,
})
export class StatsCardComponent {
  data = input.required<StatCardData>();
  loading = input<boolean>(false);

  protected numericValue(): number | null {
    const value = this.data().value;
    return typeof value === 'number' ? value : null;
  }

  protected textValue(): string {
    const value = this.data().value;
    return typeof value === 'string' ? value : '--';
  }
}
